{
	"computer": "Ordinateur",
	"notInformed": "Nom non renseigné",
	"productImage": "Photo du produit",
	"searchMoreOptions": "Consulter d'autres options dans la base de données",
	"select": "Sélectionner une photo",
	"selectFrom": "Sélectionner depuis",
	"setTagInput": "Recherche du produit à l'aide de mots-clés"
}
